import React, { useEffect, useContext, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./layouts/Layout";
import "react-toastify/dist/ReactToastify.min.css";
import "react-datetime/css/react-datetime.css";
import "react-image-lightbox/style.css";
import AppContext from "./context/Context";
import axios from "axios";
import SikkaEchartTheme from "./components/common/charts/SikkaEchartTheme";
import ErrorBoundary from "./ErrorBoundary";
import { Button, Card, CardBody, Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import { reloadPage } from "./helpers/utils";

const App = ({ hideLoader }) => {
  const [isValidLogin, setIsValidLogin] = useState(false);

  const { loginUserDetails } = useContext(AppContext);

  if (loginUserDetails) {
    window.FreshworksWidget("identify", "ticketForm", {
      name: loginUserDetails.dev_name,
      email: loginUserDetails.user_name,
    });
    window.FreshworksWidget("disable", "ticketForm", ["name", "email"]);
  }

  SikkaEchartTheme();

  return (
    <Router>
      <ErrorBoundary
        fallback={
          <>
            <Card
              className={`text-center p-5 w-100`}
              style={{
                height: "100vh",
              }}
            >
              <Col className="d-flex w-100 flex-column flex-center p-2">
                <h3
                  style={{
                    color: "red",
                  }}
                >
                  <b>WELL, THIS WASN'T WHAT YOU EXPECTED</b>
                </h3>
                <span className="border-top w-75 pl-4 pr-4 mb-4 " />
                <span className="font-weight-bold fs-1 p-1 pt-2 pb-5">
                  <p>
                    Something went wrong on our end. Please go back and try
                    again or go to home page.
                  </p>
                </span>
                <div className="d-flex align-items-center">
                  <Button
                    color="primary"
                    size="sm"
                    className="btn btn-primary btn-sm m-2"
                    onClick={() => {
                      if (loginUserDetails.is_partner == "1") {
                        window.location.replace(
                          `${process.env.PUBLIC_URL}/user/applications`
                        );
                      } else if (loginUserDetails.is_partner == "0") {
                        window.location.replace(
                          `${process.env.PUBLIC_URL}/admin/dashboard`
                        );
                      } else {
                        window.location.replace(
                          `${process.env.PUBLIC_URL}/authentication/login`
                        );
                      }
                    }}
                  >
                    <span>
                      <FontAwesomeIcon icon={faHome} className="mr-2" />
                      Take me home
                    </span>
                  </Button>
                  <Button
                    color="primary"
                    size="sm"
                    className="btn btn-primary btn-sm m-2"
                    onClick={() => {
                      localStorage.setItem("error_refresh_button", "true");
                      localStorage.removeItem("retry_loading");
                      reloadPage();
                    }}
                  >
                    <span>
                      <FontAwesomeIcon icon={faSync} className="mr-2" />
                      Refresh the Page
                    </span>
                  </Button>
                </div>
              </Col>
            </Card>
          </>
        }
      >
        <Layout hideLoader={hideLoader} />
      </ErrorBoundary>
    </Router>
  );
};

export default App;
